var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showSpinner)?_c('div',{attrs:{"id":"spinner"}},[_c('i',{staticClass:"fa fa-spinner fa-spin"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }